<div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap=".5em">
<mg-simple-form *ngIf="form" [formGroup]="form" [errorMessage]="errorMessage" label="Gebruiker" title="{{item?.firstName}} {{item?.lastName}}" (onSubmit)="onSubmit($event)" (onDelete)="onDelete()" [customActions]="customActions" [dtoClassName]="dtoTypeName">
    <br>
    <mg-simple-form-row>
            <span><mat-form-field><input type="text" placeholder="Voornaam" matInput formControlName="firstName" [readonly]="!canChangeUser()"><mat-error>{{getError('firstName')}}</mat-error></mat-form-field></span>
            <span><mat-form-field><input type="text" placeholder="Achternaam" matInput formControlName="lastName" [readonly]="!canChangeUser()"><mat-error>{{getError('lastName')}}</mat-error></mat-form-field></span>
            <span><mat-form-field><input type="email" placeholder="Email" matInput formControlName="email" [readonly]="!canChangeUser()"><mat-error>{{getError('email')}}</mat-error></mat-form-field></span>
    </mg-simple-form-row>

    <mg-simple-form-row *ngIf="canChangeUser()">
        <span mg-colspan-2 *ngIf="!item.hasRelaties">
            <mat-form-field>
                <mg-autocomplete #PersoneelAutocomplete placeholder="Personeel" formControlName="personeel" [getData]="getPersoneelDataSource" [displayFn]="personeelDisplayFn" (optionSelected)="onPersoneelSelected($event)" ></mg-autocomplete>
                <mat-error>{{getError('personeel')}}</mat-error>
                <mg-dto-link matSuffix dtoRoute="personeel" module="personeel" [dtoId]="PersoneelAutocomplete.value?.id"></mg-dto-link>
            </mat-form-field>
        </span>
        <span>
            <mat-slide-toggle color="accent" formControlName="meetInstrumenten">MeetInstrumenten</mat-slide-toggle>
            <mg-error-icon [error]="getError('meetInstrumenten')"></mg-error-icon>            
            <mat-slide-toggle color="accent" formControlName="energie">Energie</mat-slide-toggle>
            <mg-error-icon [error]="getError('energie')"></mg-error-icon>            
        </span>	
    </mg-simple-form-row>
    <br>
    <mg-simple-form-section title="Printers" *ngIf="!item.hasRelaties">

        <mg-simple-form-row>
            <span mg-colspan-2>
                <mat-form-field pd-size-max>
                    <mat-select formControlName="algemenePrinter" placeholder="Algemene Printer">
                        <mat-option *ngFor="let item of this.printers" [value]="item">{{item}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </span>
		</mg-simple-form-row>
        
		<mg-simple-form-row>
            <span mg-colspan-2>
                <mat-form-field pd-size-max>
                    <mat-select formControlName="werkbonPrinter" placeholder="Werkbon Printer">
                        <mat-option *ngFor="let item of this.printers" [value]="item">{{item}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </span>
		</mg-simple-form-row>

		<mg-simple-form-row>
			<span mg-colspan-2>
                <mat-form-field pd-size-max>
                    <mat-select formControlName="stickerPrinter" placeholder="Sticker Printer">
                        <mat-option *ngFor="let item of this.printers" [value]="item">{{item}}</mat-option>
                    </mat-select>
                </mat-form-field>
			</span>
		</mg-simple-form-row>

        <mg-simple-form-row>
            <span mg-colspan-2>
                <mat-form-field pd-size-max>
                    <mat-select formControlName="certificaatVoorbladPrinter" placeholder="Certificaat Printer (voorblad)">
                        <mat-option *ngFor="let item of this.printers" [value]="item">{{item}}</mat-option>
                    </mat-select>
                </mat-form-field>
			</span>                
		</mg-simple-form-row>

        <mg-simple-form-row>
            <span mg-colspan-2>
                <mat-form-field pd-size-max>
                    <mat-select formControlName="certificaatVolgbladPrinter" placeholder="Certificaat Printer (volgblad)">
                        <mat-option *ngFor="let item of this.printers" [value]="item">{{item}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </span>
        </mg-simple-form-row>

        <mg-simple-form-row>
            <span mg-colspan-2>
                <mat-form-field pd-size-max>
                    <mat-select formControlName="pakbonPrinter" placeholder="Pakbon Printer">
                        <mat-option *ngFor="let item of this.printers" [value]="item">{{item}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </span>
		</mg-simple-form-row>

        <mg-simple-form-row>
            <span mg-colspan-2>
                <mat-form-field pd-size-max>
                    <mat-select formControlName="factuurPrinter" placeholder="Factuur Printer">
                        <mat-option *ngFor="let item of this.printers" [value]="item">{{item}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </span>
		</mg-simple-form-row>

    </mg-simple-form-section>

    <mg-simple-form-section title="Certificaat" *ngIf="!item.hasRelaties">        

		<mg-simple-form-row>
			<span mg-colspan-2>
                <mat-form-field pd-size-max>
                    <input type="text" placeholder="Certificaat Signature" matInput formControlName="certificaatSignatureName">
                    <mat-error>{{getError('certificaatSignatureName')}}</mat-error>
                </mat-form-field>
			</span>
            <span>
                <mg-file-upload  
                    matTooltip="Kies een bestand"
                    accept="image/png" 
                    formControlNameData ="certificaatSignatureName"
                    formControlNameFileName="certificaatSignatureName" 
                    (onFileSelected)="onFileChanged($event)"
                    maxFileSize="4194304">
                </mg-file-upload>                                
			</span>
		</mg-simple-form-row>
    </mg-simple-form-section>

    <mg-simple-form-section title="Beveiliging" *ngIf="!isNewItem && CanCreate('CIJBorculo.Logic.User')">
        <mg-simple-form-row>
            <span>
                <mat-slide-toggle color="accent" formControlName="locked">Geblokkeerd</mat-slide-toggle>
                <mg-error-icon [error]="getError('locked')"></mg-error-icon>
            </span>
            <span></span>
            <span>
                <mat-form-field>
                    <mat-datetimepicker #pickerlastPasswordChange type="datetime" timeInterval="5" [disabled]="true"></mat-datetimepicker>
                    <input matInput formControlName="lastPasswordChanged" [matDatetimepicker]="pickerlastPasswordChange" placeholder="Laatste keer wachtwoord gewijzigd" [disabled]="true">
                </mat-form-field>
            </span>
        </mg-simple-form-row>
        <mg-simple-form-row>
            <span>
                <mat-slide-toggle color="accent" formControlName="internalLogin">Interne User</mat-slide-toggle>
                <mg-error-icon [error]="getError('internalLogin')"></mg-error-icon>
            </span>
            <span></span>
            <span>
            </span>
        </mg-simple-form-row>
        <br>
        <label class="label-header">Two-Factor Authentication</label>
        <br><br>
        <mg-simple-form-row>
            <span>
                <mat-slide-toggle color="accent" formControlName="mfaEnabled" >Geregistreerd door gebruiker</mat-slide-toggle>                
            </span>
        </mg-simple-form-row>
        <mg-simple-form-row>
            <span>
                <mat-slide-toggle color="accent" formControlName="isMfaExempt" >Vrijgesteld van 2FA</mat-slide-toggle>                
            </span>
        </mg-simple-form-row>
    </mg-simple-form-section>

</mg-simple-form>

<div fxLayout="column" style="float: left;">
    <mat-tab-group>
        <mat-tab *ngIf="!isNewItem && !isArchived() && CanRead('Mango.Authorization.Group')">
            <ng-template mat-tab-label>
                <div class="col" style="margin-left: 20px;">Groepen</div>
            </ng-template> 
            <mg-subcollection title="Groepen" *mgIfCanRead="'Mango.Authorization.Group'" addable="false">
                <mg-authorization-group-user-collection #collection [user]="this.item"></mg-authorization-group-user-collection>
            </mg-subcollection>
        </mat-tab>

        <mat-tab *ngIf="!isNewItem && item.personeel == null && !isArchived() && CanRead('CIJBorculo.Logic.RelatieUser')">
            <ng-template mat-tab-label> 
                <div class="col" style="margin-left: 20px;">Relaties</div>
            </ng-template> 
            <mg-subcollection title="Relaties"
                *mgIfCanRead="'CIJBorculo.Logic.RelatieUser'"
                [deletable]="false"
                [newItem]="{ user: { id: item?.id, firstName: item?.firstName, lastName: item?.lastName } }">
                <c-i-j-borculo-relatie-user-collection #collection [user]="this.item"></c-i-j-borculo-relatie-user-collection>
            </mg-subcollection>
        </mat-tab>

        <mat-tab *ngIf="CanRead('Mango.Authentication.TrustedDevice') && !this.isNewItem">
            <ng-template mat-tab-label>
                <div class="col" style="margin-left: 20px;">Vertrouwd</div>
            </ng-template>
            <mg-trusted-devices [user]="this.item"></mg-trusted-devices>
        </mat-tab>

        <mat-tab *ngIf="!isNewItem && CanRead('Mango.Authentication.UserLoginHistory')">
            <ng-template mat-tab-label>
                <div class="col" style="margin-left: 20px;">Login Historie</div>
            </ng-template> 
            <mg-subcollection title="Login Historie" *mgIfCanRead="'Mango.Authentication.UserLoginHistory'" addable="false" deletable="false">
                <user-login-history-collection #collection [user]="this.item" [defaultPageSize]="20"></user-login-history-collection>
            </mg-subcollection>
        </mat-tab> 

        <mat-tab *ngIf="!isNewItem && CanRead('Mango.Authorization.Role')">
            <ng-template mat-tab-label>
                <div class="col" style="margin-left: 20px;">Rechten</div>
            </ng-template> 
            <mg-user-roles-overview *mgIfCanRead="'Mango.Authorization.Role'" [showExplicitProperties]="false" [user]="this.item"></mg-user-roles-overview>
        </mat-tab>

    </mat-tab-group>
</div>
</div>
